<template>
  <div class="group-wrap">
    <div class="check-all" @click="checkAllBtn">
      <span class="check-btn">
        <van-icon class="checkbox-btn" color="#ccc" v-if="!isAllChecked" name="circle" />
        <van-icon class="checkbox-btn" color="#267dff" v-else name="checked" />
      </span>
      <span class="group-name">全选</span>
    </div>
    <div v-for="item in groupList" :key="item.GroupID">
      <div class="check-all"  @click="checkedBtn(item)">
        <span class="check-btn">
        <van-icon class="checkbox-btn" color="#ccc" v-if="!item.Checked" name="circle" />
        <van-icon class="checkbox-btn" color="#267dff" v-else name="checked" />
        </span>
        <img :src="require('@/assets/evaluation/icons.svg')" alt="" class="icons">
        <span class="group-name nowrap">{{item.GroupName}}</span>
      </div>
      <div class="group-score">
        <div>
          <div class="score">{{item.GroupValue}}</div>
          <div class="text">小组得分</div>
        </div>
        <div>
          <div class="score">{{item.GroupRank}}</div>
          <div class="text">小组排名</div>
        </div>
        <div>
          <div class="score">{{item.GroupRankingValue}}</div>
          <div class="text">小组排名积分</div>
        </div>
      </div>
    </div>    
    <van-number-keyboard
      :show="numberKeyWordShow"
      theme="custom"
      v-model="scoreTotal"
      extra-key="00"
      delete-button-text="删除"
      close-button-text="完成"
      @blur="numberKeyWordShow = false"
    />
    <div class="group-bottom">
      <div class="calculation-ing">
        <i class="iconfont del" @click="delBtn">&#xe6d0;</i>
        <van-field
          class="nums"
          readonly
          clickable
          :value="scoreTotal"
          placeholder="点此输入"
          @touchstart.native.stop="numberKeyWordShow=true"
        />
        <i class="iconfont add" @click="addBtn">&#xe6d7;</i>
      </div>
      <div class="conser-btn" @click="conserBtn">保存</div>
    </div>
  </div>
</template>
<script>
import { Notify } from "vant"
export default {
  data() {
    return {
      num:'1',
      scoreTotal:'1',
      numberKeyWordShow:false,
      isAllChecked:false,
      groupList:[],
      options:[]
    }
  },
  watch:{
    num:{
      handler(val){
        this.scoreTotal= val.toString()
      },
      deep:true,
      immediate:true
    }
  },
  created(){
    this.getGroupData(this.$store.state.evaluation.averageObj)
  },
  methods:{
    getGroupData(obj){
      this.xy.loading()
      this.isAllChecked=false
      this.groupList=[]
      this.scoreTotal='1'
      this.num='1'
      this.xyapi.get(`${this.$store.state.apiPath}/api/ClassRoomGroupRecord/GetClassRoomRecordGroupInfo`,{
        schoolDistrictID:obj.SchoolDistrictID,
        academicSessionID:obj.AcademicSessionID,
        classTableGenerateBaseID:obj.ClassTableGenerateBaseID,
        coursePlanAID:obj.CoursePlanAID,
        coursePlanAIDType:obj.CoursePlanAIDType.toString()
      }).then(res=>{
        if(res.success){
          this.groupList=res.data
          this.groupList.map(item=>{
            this.$set(item,'Checked',false)
          })
          if(res.data.length===0){
              Notify({ type: "warning", message: res.msg  })
          }
        }
        this.xy.unloading()
      })
    },
    checkAllBtn(){
      this.isAllChecked=!this.isAllChecked
      this.groupList.map(item=>{
        item.Checked=this.isAllChecked?true:false
      })
    },
    checkedBtn(val){
      val.Checked=!val.Checked
      let isChecked = this.groupList.filter(item=>{
        return !item.Checked
      })
      this.isAllChecked=isChecked.length>0?false:true
    },
    delBtn(){
      this.num=Number(this.scoreTotal)
      if(this.num>1){
        this.num--
      }else{
        this.num=1
      }
    },
    addBtn(){
      this.num=Number(this.scoreTotal)
      this.num++
    },    
    conserBtn(){
      this.options=[]
      let obj=this.$store.state.evaluation.averageObj
      for(let i=0,len=this.groupList.length;i<len;i++){
        if(this.groupList[i].Checked){
          this.options.push({
          GroupID:this.groupList[i].GroupID,
          ProgrammeRecordGroupID:this.groupList[i].ProgrammeRecordGroupID,
          GroupValue:this.groupList[i].GroupValue,
          GroupRank:this.groupList[i].GroupRank,
          GroupRankingValue:this.groupList[i].GroupRankingValue,
          AddFraction:Number(this.scoreTotal)
        })
        }
      }
      if(this.options.length<1){
        this.xy.msgError('请先选择小组')
        return false
      }
      if(Number(this.scoreTotal)<1){
        this.xy.msgError('小组评分不能低于1分')
        return false
      }
      this.xy.loading()
      this.xyapi.post(`${this.$store.state.apiPath}/api/ClassRoomGroupRecord/CreateClassRoomRecordGroup`,{
        SchoolDistrictID: obj.SchoolDistrictID,
        AcademicSessionID: obj.AcademicSessionID,
        ClassTableGenerateBaseID: obj.ClassTableGenerateBaseID,
        CoursePlanAID: obj.CoursePlanAID,
        CoursePlanAIDType: obj.CoursePlanAIDType,
        DisciplineID: obj.DisciplineID,
        AcademicYearID: obj.AcademicYearID,
        StudentGradeForStudentYearID: obj.StudentGradeForStudentYearID,
        GroupFraction:this.options
      }).then(res=>{
        if(res.success){
          this.xy.msgSuc('保存成功')
          this.getGroupData(this.$store.state.evaluation.averageObj)
        }
        this.xy.unloading()
      })
    },
  }
}
</script>  
<style lang="less" scoped>
.group-wrap{  
  background: #fff;
  padding-left:30px;
  .check-all{
    height: 80px;
    display: flex;
    align-items: center;
    .check-btn{
      line-height: 0;
      margin-right:20px;
      .checkbox-btn{
        font-size: 44px;
      }
    }
    img.icons{
      width: 42px;
      height: 42px;
      margin-right:10px;
    }
    .group-name{
      font-size: 30px;
      padding-right: 30px;
      color: rgba(0,0,0,0.85);
    }
  }
  .group-score{
    display: flex;
    justify-content: space-between;
    margin: 24px 0 0 70px;
    padding:0 30px 30px 0;
    border-bottom: 1px solid rgba(0,0,0,.1);
    .score{
      font-size: 40px;
      color: rgba(0,0,0,0.85);
      font-weight: 700;
    }
    .text{
      font-size: 24px;
      color: rgba(0,0,0,0.45);
    }
    div{
      text-align: center;
    }
  }
  .group-bottom{
    position: fixed;
    bottom:0;
    left: 0;
    right:0;
    height: 100px;
    border-top: 1px solid #eee;
    box-shadow: -1px 1px 4px 0px rgba(171,171,171,0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0 30px;
    background: #fff;
    .calculation-ing{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nums{
        width:180px;
        font-size: 34px;
        color: #000;
        margin:0 20px;
      }
      i{
        font-size: 47px;
        color:#267dff;
      }
    }
    .conser-btn{
      width: 210px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      background: #267dff;
      border-radius: 40px;
      color:#fff;
      font-size: 36px;
    }
  }
}
</style>